module.exports = __webpack_public_path__ + "static/img/page01-txt.2efbb94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page01-txt.png
// module id = HjDS
// module chunks = 1